import React, { useEffect, useState } from "react";
import SideBar from "./Sidebar";
import Header from "./Header";

import "./Layout.css";
import Main from "./Main";

function LayoutDashboard(props) {
  // states
  const [showMenu, setShowMenu] = useState(true); // for hide/show buger
  const [mobileView, setMobileView] = useState(false); // for mobile screen

  const toggleMenu = () => setShowMenu(!showMenu);

  return (
    <>
      <div className="layout">
        <header className="layout__header">
          <Header />
        </header>
        <div className="layout__body">
          <SideBar history={props.history} />
          <Main content={props.children} router={props} />
        </div>
      </div>
    </>
  );
}

export default LayoutDashboard;
